import React, { lazy, Suspense } from 'react';

import CardListSkeleton from '@monorepo/common/components/CardListSkeleton';

const DealsList = lazy(() => import('./DealsList'));

export default (props: Config) => (
  <Suspense fallback={<CardListSkeleton />}>
    <DealsList {...props} />
  </Suspense>
);
